import React from 'react';
import FeaturedCallOut from './FeaturedCallOut';
import {HomeRouteContext} from 'utils/context';

const FeaturedCallOutsSection = ({callOuts}) => {
    if (!callOuts || !callOuts.length) {
        return null;
    }

    const renderedCallOuts = callOuts.map((callOut, i) => {
        const {parent, path, __typename} = callOut;
        const isArticle = __typename === 'Article';

        return (
            <HomeRouteContext.Consumer key={`callout-${i}`}>
                {(homeRoute) => (
                    <FeaturedCallOut
                        subtitle={isArticle && parent && parent.name}
                        link={`${homeRoute}${path}`}
                        withButton={!isArticle}
                        {...callOut}
                    />
                )}
            </HomeRouteContext.Consumer>
        );
    });

    return (
        <section className="FeaturedCallOutsSection hub-section">
            {renderedCallOuts}
        </section>
    );
};

export default FeaturedCallOutsSection;
